module.exports = __webpack_public_path__ + "static/media/home-merch-water-bottle.04fc916a.png";